import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  logo: {
    id: 'studio.k81S1y',
    defaultMessage: 'Logo',
  },
});
